import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authContext } from "../contexts/AuthProvider";
import { loaderContext } from "../contexts/LoaderProvider";
import Loader from "../layout/Loader";
import {
  pendingOrders,
  driverOrders,
  failedOrders,
  enRouteOrders,
  completedOrders,
} from "../services/orderService";
import QRCodeGenerator from "../utils/QRCodeGenerator";
import Completed from "./layout/Completed";
import Order from "./layout/Order";
import Pending from "./layout/Pending";
import Driver from "./layout/Driver";
import EnRoute from "./layout/EnRoute";
import Failed from "./layout/Failed";

const ManageOrders = ({ hideMap, setHideMap }) => {
  const [modal, setModal] = useState({ open: false });
  const { isLoading, setIsLoading } = useContext(loaderContext);
  const [isAuth] = useContext(authContext);
  const navigate = useNavigate();
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  useEffect(() => {
    if (isAuth === true) {
      setIsLoading(false);
    }
    if (isAuth === false) {
      navigate("/");
    }
  }, [isAuth, navigate, setIsLoading]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <>
      <div className="row">
        <Order
          Layout={Completed}
          setModal={setModal}
          fetchOrders={completedOrders}
          hideMap={hideMap}
          setHideMap={setHideMap}
        />
        <Order
          Layout={Pending}
          setModal={setModal}
          fetchOrders={pendingOrders}
          height={hideMap === true || isMobile === true ? `auto` : `40vh`}
        />
        <Order
          Layout={Driver}
          setModal={setModal}
          fetchOrders={driverOrders}
          height={hideMap === true || isMobile === true ? `auto` : `40vh`}
        />
        <Order
          Layout={EnRoute}
          setModal={setModal}
          fetchOrders={enRouteOrders}
          height={hideMap === true || isMobile === true ? `auto` : `40vh`}
        />
        <Order
          Layout={Failed}
          setModal={setModal}
          fetchOrders={failedOrders}
          height={hideMap === true || isMobile === true ? `auto` : `40vh`}
        />
      </div>
      <div
        className={
          modal?.open === true
            ? "modal fade effect-slide-in-bottom show bg-success-transparent"
            : "modal fade effect-slide-in-bottom"
        }
        style={modal?.open === true ? { display: "block" } : {}}
      >
        <div
          className="modal-dialog modal-dialog-centered text-center modal-sm"
          role="document"
        >
          <div className="modal-content modal-content-demo">
            <div className="modal-header">
              <h6 className="modal-title">{modal?.customerName}</h6>
              <button
                onClick={() => {
                  setModal({ open: false });
                }}
                aria-label="Close"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body text-center">
              <QRCodeGenerator orderId={modal?.orderId} />
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ManageOrders;
